import { useRouter } from "next/router";
import React from "react";
import { Event } from "../../../context/eventsContext/reducer";
import ReadMore from "../Buttons/ReadMore";
import EventDate from "./elements/EventDate";
import EventLocation from "./elements/EventLocation";
import { formatDistance } from 'date-fns'

const EventHero = (props: { 
  className?: string,
  event: Event
}) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/events/${ props.event.slug }`)
  }
  
  return (
    <div
      className={`rounded article-container transition shadow-lg overflow-hidden lg:flex cursor-pointer ${props.className}`}
      onClick={handleClick}
      onKeyDown={(e) => {if (e.key === "Enter") handleClick()}}
      role="button"
      tabIndex={0}
    >
      <div className="relative overflow-hidden w-full xl:w-2/3">
        <div
          className="article-image h-0 aspect-16/9 w-full bg-cover bg-center flex items-center justify-center"
          style={{
            backgroundImage: `url("${props.event.image_url}")`
          }}
        >
          {
            props.event.image_url.includes('missing.png') &&
            <div className="relative p-12 w-full">
              <div className="absolute -inset-20 z-10 leading-10 text-3xl font-bold text-red opacity-5 transform -rotate-12">
                {(props.event.title + " ").repeat(100)}
              </div>
              <div className="relative flex items-center bg-white backdrop-filter bg-blur bg-opacity-20 justify-center p-8 text-center text-xl h-48 border border-red border-opacity-30 z-30">
                {props.event.title}
              </div>
            </div>
          }
        </div>
      </div>
      <div className="p-5 flex flex-col w-full xl:w-full relative">
        <div className="h-full space-y-1 flex flex-col">
          <div className="font-normal text-sm opacity-60 pb-2">
            Starts in { formatDistance(new Date(props.event.date.replace(/-/g, '\/')), new Date()) }
          </div>

          <h2 className="transition font-bold text-3xl">
            {props.event.title}
          </h2>

          <p className="font-light h-full">{props.event.preview}</p>

          <div>
            <EventDate
              className="w-full"
              event={props.event}
            />

            <EventLocation 
              event={props.event}
            />
          </div>
        </div>

        <ReadMore
          className="pt-4 absolute bottom-5 left-0 right-6"
          label=" "
          link="#"
          needLink={false}
        />
      </div>
    </div>
  );
};

export default EventHero;
